import { memo } from 'react'
import { useBackendConnection } from '../hooks/useBackendConnection'
import { useI18n } from '../i18n/I18nContext'

export const ConnectionStatus = memo(function ConnectionStatus() {
  const { t } = useI18n()
  const { isConnected, isChecking, error, checkConnection, apiBaseUrl } = useBackendConnection()

  if (isConnected || (isChecking && !error)) {
    return null
  }

  return (
    <div className="connection-status">
      <div className="connection-status-content">
        <div className="connection-status-header">
          <span className="connection-icon">🔌</span>
          <div>
            <h4>{t('connection.title')}</h4>
            <p className="connection-url">{apiBaseUrl}</p>
          </div>
        </div>

        {isChecking ? (
          <div className="connection-checking">
            <div className="spinner spinner-small"></div>
            <span>{t('connection.checking')}</span>
          </div>
        ) : error ? (
          <div className="connection-error">
            <p className="error-message">{error}</p>
            <div className="connection-help">
              <p><strong>{t('connection.solutionsTitle')}</strong></p>
              <ol>
                <li>{t('connection.hint1')}</li>
                <li>{t('connection.hint2')}</li>
                <li>{t('connection.hint3')}</li>
                <li>{t('connection.hint4')}</li>
              </ol>
            </div>
            <button type="button" onClick={checkConnection} className="btn-primary">
              {t('connection.retry')}
            </button>
          </div>
        ) : null}
      </div>
    </div>
  )
})
